export default function createTextOverlay(googleApi){
    function TxtOverlay(pos, txt, cls, map) {
        this.pos = pos;
        this.txt_ = txt;
        this.cls_ = cls;
        this.map_ = map;
        this.div_ = null;
        this.setMap(map);
    }
    TxtOverlay.prototype = new googleApi.maps.OverlayView();
    TxtOverlay.prototype.onAdd = function() {
        var div = document.createElement('DIV');
        div.className = this.cls_;
        div.innerHTML = this.txt_;
        this.div_ = div;
        var overlayProjection = this.getProjection();
        var position = overlayProjection.fromLatLngToDivPixel(this.pos);
        div.style.left = position.x-(this.txt_.length-11)*3 + 'px';
        div.style.top = position.y-7 + 'px';
        div.style.textAlign = 'center'
        var panes = this.getPanes();
        panes.floatPane.appendChild(div);
    }
    TxtOverlay.prototype.draw = function() {
        var overlayProjection = this.getProjection();
        var position = overlayProjection.fromLatLngToDivPixel(this.pos);
        var div = this.div_;
        div.style.left = position.x-(this.txt_.length-11)*3 + 'px';
        div.style.top = position.y-7 + 'px';
        div.style.textAlign = 'center'
    }
    return TxtOverlay
}

